import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CompanyListItemDto } from "@green0meter/api-client";

import { EntitiesTable, EntityEditor } from "./components";
import EntitiesManagementSkeleton from "./EntitiesManagement.skeleton";

import { useDisclose } from "@hooks/useDisclose";
import { Button, Stack, Typography } from "@components/base";
import { useGetCompanies } from "@api";
import { useUserStore } from "@store/user";

interface EntitiesManagement {}

const EntitiesManagement: React.FC<EntitiesManagement> = () => {
  const { t } = useTranslation();
  const [companyId, setCompanyId] = useState<string>();
  const { user } = useUserStore();
  const { isPendingGetCompanies, companiesEnabled } = useGetCompanies(user);

  const {
    isOpen: isEntityEditorOpen,
    onOpen: openEntityEditor,
    onClose: closeEntityDialog,
  } = useDisclose();

  const handleAddEntityButtonClick = (): void => {
    setCompanyId(undefined);
    openEntityEditor();
  };

  const handleClose = (): void => {
    setCompanyId(undefined);
    closeEntityDialog();
  };

  const handleTableRowClick = (entity: CompanyListItemDto): void => {
    setCompanyId(entity.id);
    openEntityEditor();
  };

  return (
    companiesEnabled &&
    (isPendingGetCompanies ? (
      <EntitiesManagementSkeleton />
    ) : (
      <>
        <Stack spacing={3} mt={3}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography>{t("organization.entities")}</Typography>
            <Button onClick={handleAddEntityButtonClick}>{t("common.add")}</Button>
          </Stack>
          <EntitiesTable onRowClick={handleTableRowClick} />
        </Stack>
        <EntityEditor
          key={`${companyId ?? "new"}`}
          isOpen={isEntityEditorOpen}
          onClose={handleClose}
          companyId={companyId}
        />
      </>
    ))
  );
};

export default EntitiesManagement;
